import { render, staticRenderFns } from "./rich_text_editor.vue?vue&type=template&id=2f8942f6&scoped=true&"
import script from "./rich_text_editor.vue?vue&type=script&lang=js&"
export * from "./rich_text_editor.vue?vue&type=script&lang=js&"
import style0 from "./rich_text_editor.vue?vue&type=style&index=0&id=2f8942f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8942f6",
  null
  
)

export default component.exports